import React from "react";

const DashboardPage = ({ listings, setActiveTab, setShowAddListingModal }) => {
  return (
    <div className="space-y-8">
      {/* Header Section */}
      <div className="text-center">
        <h1 className="dark-header text-[#000]">Real Estate Dashboard</h1>
        <p className="light-header">Manage your properties and grow your business</p>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300">
          <div className="flex items-center justify-between">
            <div>
              <p className="light-header !text-[#949995] !mb-2">Total Listings</p>
              <p className="dark-header !text-[#10c9c0] !mb-0">{listings.length}</p>
            </div>
            <div className="w-12 h-12 bg-gradient-to-br from-[#10c9c0] to-[#0eb1a9] rounded-xl flex items-center justify-center">
              <i className="fas fa-home text-white text-lg"></i>
            </div>
          </div>
        </div>
        
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300">
          <div className="flex items-center justify-between">
            <div>
              <p className="light-header !text-[#949995] !mb-2">Featured</p>
              <p className="dark-header !text-[#10c9c0] !mb-0">
                {listings.filter(listing => listing.featured).length}
              </p>
            </div>
            <div className="w-12 h-12 bg-gradient-to-br from-[#10c9c0] to-[#0eb1a9] rounded-xl flex items-center justify-center">
              <i className="fas fa-star text-white text-lg"></i>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
        <h3 className="dark-header !text-[#000] !mb-6">Quick Actions</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <button 
            onClick={() => setShowAddListingModal(true)}
            className="flex items-center justify-center px-6 py-4 bg-gradient-to-r from-[#10c9c0] to-[#0eb1a9] text-white rounded-xl hover:from-[#0eb1a9] hover:to-[#10c9c0] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            <i className="fas fa-plus mr-3"></i>
            <span className="font-medium">Add New Listing</span>
          </button>
          <button className="flex items-center justify-center px-6 py-4 bg-gradient-to-r from-[#10c9c0] to-[#0eb1a9] text-white rounded-xl hover:from-[#0eb1a9] hover:to-[#10c9c0] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
            <i className="fas fa-external-link-alt mr-3"></i>
            <span className="font-medium">View My Page</span>
          </button>
          <button 
            onClick={() => setActiveTab('profile')}
            className="flex items-center justify-center px-6 py-4 bg-gradient-to-r from-[#10c9c0] to-[#0eb1a9] text-white rounded-xl hover:from-[#0eb1a9] hover:to-[#10c9c0] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            <i className="fas fa-cog mr-3"></i>
            <span className="font-medium">Edit Profile</span>
          </button>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
        <h3 className="dark-header !text-[#000] !mb-6">Recent Activity</h3>
        <div className="space-y-4">
          {listings.slice(0, 3).map((listing) => (
            <div key={listing.property_id} className="flex items-center justify-between p-4 bg-[#fafafa] rounded-xl">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-gray-200 to-gray-300 rounded-lg flex items-center justify-center">
                  <i className="fas fa-building text-gray-600"></i>
                </div>
                <div>
                  <p className="font-medium text-[#000]">{listing.Address}</p>
                  <p className="light-header !text-[#949995] !mb-0">{listing.Empty_or_Not}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="font-bold text-[#10c9c0]">¥{parseInt(listing.Price.replace(/\D/g, '')).toLocaleString()}</p>
                <p className="light-header !text-[#949995] !mb-0">{listing.Year_of_Construction}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;